import React from 'react';

// Die vorhandenen Bildressourcen werden über stabile Backend-Codes zugeordnet.
// Labels werden nicht hartcodiert, sondern aus dem Entscheidungsbaum angezeigt.
const areaIcons = {
  '1': '/images/icons/Kategorie/Kategorie-Auto1.svg',
  '2': '/images/icons/Kategorie/Kategorie-Lenkrad.svg',
  '3': '/images/icons/Kategorie/Kategorie-Moebel1.svg',
  '4': '/images/icons/Kategorie/Kategorie-Tasche1.svg',
  '5': '/images/icons/Kategorie/Kategorie-Kleidung1.svg',
  '6': '/images/icons/Kategorie/Kategorie-Schuhe1.svg'
};
const problemImages = {
  '0': 'impragnierung.jpg', '1': 'verschmutzungen.jpg', '2': 'gebrauchsspuren.jpg',
  '3': 'risse.jpg', '4': 'kratzer.jpg', '5': 'jeansabfarbung.jpg', '6': 'ausbleichung.jpg',
  '7': 'farbablosung.jpg', '8': 'olflecken.jpg', '9': 'wasserflecken.jpg',
  '10': 'glanzgrad.jpg', '11': 'reifenabdrucke.jpg', '12': 'verhartet.jpg',
  '13': 'sekundenkleberflecken.jpg', '14': 'kugelschreiber.jpg', '15': 'fettstellen.jpg',
  '16': 'rauchgeruch.jpg', '17': 'schimmelbildung.jpg', '18': 'knarzgerausche.jpg',
  '19': 'rutschige-leder.jpg'
};
const materialImages = {
  '1': 'Unbekannt-Material-normal.jpg', '2': 'Glattleder-Material-normal.jpg',
  '3': 'Semianilin-Material-normal.jpg', '4': 'Longlife-Material-normal.jpg',
  '5': 'Anilin-Material-normal.jpg', '6': 'Nubukleder-Material-normal.jpg',
  '7': 'Fettleder-Material-normal.jpg', '8': 'Antikleder-Material-normal.jpg',
  '9': 'PuLeder-Material-normal.jpg', '10': 'Buffelleder-Material-normal.jpg',
  '11': 'Exotenleder-Material-normal.jpg', '12': 'Kunstleder-Material-normal.jpg',
  '13': 'Stoff-Material-normal.jpg', '14': 'Vegan-Material-normal.jpg'
};

/** Liefert das passende Bestandsbild für eine Auswahlkachel. */
function imageFor(kind, code, scope) {
  if (kind === 'area') return areaIcons[code] || '';
  let file = kind === 'area'
    ? ''
    : kind === 'problem'
      ? problemImages[code]
      : kind === 'material'
        ? materialImages[code]
        : '';
  if (kind === 'problem' && code === '18' && scope === '3') file = 'knarzgerausche-mobel.jpg';
  return file ? `${process.env.PUBLIC_URL}/images/produktfinder/${file}` : '';
}

/**
 * Wiederverwendbares, tastaturbedienbares Kachelraster für alle Frageschritte.
 * Native Buttons liefern Fokus-, Enter- und Leertastenverhalten ohne Zusatz-JS.
 */
export default function ChoiceGrid({kind, options, selected, onSelect, scope}) {
  return (
    <div className={`pf-choice-grid pf-choice-grid--${kind}`}>
      {options.map((option) => {
        const image = imageFor(kind, option.code, scope);
        const active = selected === option.code;
        return (
          <button
            type="button"
            className={`pf-choice${active ? ' is-active' : ''}${image ? '' : ' pf-choice--text'}`}
            aria-pressed={active}
            onClick={() => onSelect(option.code)}
            key={option.code}
          >
            {image && <img src={image} alt="" loading="lazy" />}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
